"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const spec = __importStar(require("./generated"));
const id = __importStar(require("../id/id"));
const ExpandedNodeId_1 = __importDefault(require("./ExpandedNodeId"));
const decode_1 = __importDefault(require("./decode"));
const registry = new Map();
registry;
exports.decodeService = (b, position) => {
    const typeId = new ExpandedNodeId_1.default();
    position = typeId.decode(b, position);
    // b = b.subarray(n)
    // create new instance from given type id
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const name = id[typeId.NodeId.Type];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const service = new spec[name]();
    // decode(b, service, position)
    decode_1.default({
        bytes: b,
        instance: service,
        position
    });
    return {
        typeId,
        service
    };
};
